import { useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../../config/api";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";

const ImportarVenta = ({ onClose, token, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleImportar = async () => {
    if (!archivo) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("archivo", archivo);

    try {
      const response = await axios.post(
        buildApiUrl("/api/ventas/importar"), 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { success, resultados } = response.data;

      if (success) {
        const errores = resultados.filter((r) => r.accion === "error");
        if (resultados.length > 0) {
          if (errores.length > 0) {
            toast.error(
              <div>
                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  Errores en la importación
                </div>
                <div style={{ fontSize: "14px" }}>
                  {errores.map((e, index) => (
                    <div key={index}>
                      Codigo: {e.documento} — Motivo: {e.motivo}
                    </div>
                  ))}
                </div>
              </div>,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              }
            );
          }
        } else {
          toast.success("Ventas Importados Exitosamente", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

        }
      }
      setLoading(false);
      onSuccess()
      onClose();
    } catch (error) {
      setLoading(false);
      const mensajeError =
        error.response?.data?.error || "Error inesperado al importar";
      toast.error(` ${mensajeError}`);
    }
  };

  return (
    <div className="modal-overlay-import">
      {loading && <Preloader />}
      <div className="modal-box-import">
        <div className="modal-header">
          <span> Importar Ventas</span>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content-import">
          <label htmlFor="archivo">Selecciona un archivo Excel:</label>
          <input
            type="file"
            id="archivo"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="save-btn" onClick={handleImportar}>
            Importar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportarVenta;
